import React from 'react';
import { AppBar, Toolbar, Box } from '@mui/material';

const Logo = require('../../src/adaptive-icon.png');

export default function AppBarComponent() {
  return (
    <>
        <AppBar
            sx={{
                backgroundColor: 'transparent'
            }}
            position='absolute'
            elevation={0}
        >
            <Toolbar style={{backgroundColor: 'transparent'}}  >
                <Box 
                    component='img'
                    src={Logo}
                    sx={{
                        height: {xs: 200 , sm: 200, md: 160, lg: 150, xl: 150}
                    }}
                    alt="iDo Logo"
                />
            </Toolbar>
        </AppBar>
    </>
  );
}
